import React, { Component } from "react"
import {
  Button,
  Card,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import {
  FaBook,
  FaChalkboardTeacher,
  FaCog,
  FaFolder,
  FaList,
  FaUserCog,
  FaEye,
  FaFileInvoiceDollar,
  FaClipboard,
  FaCheckCircle,
  FaCalendar,
  FaCalendarDay,
  FaPen,
  FaFolderOpen,
  FaPrint,
  FaCalendarAlt,
  FaUserClock,
  FaDoorOpen,
  FaCompass,
  FaGraduationCap,
  FaChild,
  FaNewspaper,
  FaInfoCircle,
  FaUser,
  FaUniversity,
  FaClipboardList,
  FaCheck,
  FaTimes,
} from "react-icons/fa"
import { FaCalendarDays } from "react-icons/fa6"
import Stats from "../Statistique/Stats"
import logo from "../../assets/images/edurasite700.png"
import API from "../../api"

// Données de tuiles (inchangées)
const tiles = [
  {
    title: "Edura Enseignant",
    icon: <FaUserCog />,
    iconCheck: <FaCheck />,
    color: "#0E918C",
    details: [
      {
        title: "Emploi enseignant par département (chef département)",
        icon: <FaChalkboardTeacher />,
        color: "#DA919F",
      },
      { title: "Fiche pédagogique", icon: <FaClipboard />, color: "#B6D8F2" },
      {
        title: "Fiche pédagogique libre (chef département)",
        icon: <FaCheckCircle />,
        color: "#F4CFDF",
      },
      { title: "Avis d'absence", icon: <FaClipboard />, color: "#5784BA" },
      {
        title: "Fiche de voeux surveillance",
        icon: <FaClipboard />,
        color: "#75BB99",
      },
      {
        title: "Emploi de groupe par département",
        icon: <FaCalendar />,
        color: "#AFA4CE",
      },
      {
        title: "Emploi enseignant",
        icon: <FaCalendarDays />,
        color: "#FEAC82",
      },
      { title: "Registre", icon: <FaCalendarDay />, color: "#F5DF4D" },
      { title: "Avis de DS", icon: <FaPen />, color: "#939597" },
      { title: "Surveillance", icon: <FaEye />, color: "#8CACD3" },
      { title: "Bibliothèque", icon: <FaFolderOpen />, color: "#E8AABE" },
      { title: "Demande Tirage", icon: <FaPrint />, color: "#4AA3A2" },
    ],
  },
  {
    title: "Edura Étudiant",
    icon: <FaChalkboardTeacher />,
    iconCheck: <FaCheck />,
    color: "#F3BB00",
    details: [
      { title: "Emploi du temps", icon: <FaCalendarDays />, color: "#FFD777" },
      { title: "Calendrier examen", icon: <FaCalendar />, color: "#8CACD3" },
      { title: "Demandes", icon: <FaClipboardList />, color: "#939597" },
      { title: "Résultat", icon: <FaGraduationCap />, color: "#4AA3A2" },
    ],
  },
  {
    title: "Edura Doctorat",
    icon: <FaList />,
    iconCheck: <FaCheck />,
    color: "#8FB43A",
  },
  {
    title: "Edura scolarité",
    icon: <FaCog />,
    iconCheck: <FaCheck />,
    color: "#009CFE",
    details: [
      { title: "Gestion étudiants", icon: <FaChild />, color: "#FFD777" },
      {
        title: "Gestion enseignant",
        icon: <FaChalkboardTeacher />,
        color: "#8CACD3",
      },
      { title: "Formation", icon: <FaList />, color: "#939597" },
      { title: "Education", icon: <FaBook />, color: "#4AA3A2" },
      { title: "Emploi enseignant", icon: <FaCalendarDay />, color: "#F0BE86" },
      { title: "Génération automatique d'emploi du temps", icon: <FaCalendarDay />, color: "#FE4B4B" },
      { title: "Emploi groupes", icon: <FaCalendarDay />, color: "#F5DF4D" },
      { title: "Emploi salles", icon: <FaCalendarDay />, color: "#C8D6A2" },
      { title: "PDF / EXCEL", icon: <FaNewspaper />, color: "#FBBFB8" },
      { title: "Gestion Utilisateur", icon: <FaUser />, color: "#BE9CC7" },
      { title: "Avis d'absence", icon: <FaPen />, color: "#7B9DD2" },
      { title: "Avis de rattrapage", icon: <FaInfoCircle />, color: "#B9DCFE" },
      { title: "Avis de DS", icon: <FaPen />, color: "#00B6DA" },
      { title: "Registre", icon: <FaCalendarDays />, color: "#F7995E" },
      { title: "Gestion d'examen", icon: <FaUniversity />, color: "#FFA5C5" },
      {
        title: "Calendrier de surveillance",
        icon: <FaCalendarAlt />,
        color: "#4F996D",
      },
      { title: "Historique", icon: <FaUserClock />, color: "#9C7F89" },
      { title: "Demande de terrain", icon: <FaDoorOpen />, color: "#84C08E" },
      { title: "Semestre", icon: <FaNewspaper />, color: "#C96A72" },
      { title: "Demandes de ligne", icon: <FaClipboard />, color: "#7E9591" },
      { title: "Orientation", icon: <FaCompass />, color: "#B4BAFF" },
    ],
  },
  {
    title: "Edura Mastère",
    icon: <FaList />,
    iconCheck: <FaTimes />,
    color: "#2362B0",
    details: [
      {
        title: "Publication et gestion des mastères",
        icon: <FaCalendarDays />,
        color: "#FFD777",
      },
      {
        title: "Gestion des candidatures et des critères d'admission",
        icon: <FaCalendar />,
        color: "#8CACD3",
      },
      {
        title: "Gestion des dossiers numériques des candidats",
        icon: <FaClipboardList />,
        color: "#939597",
      },
      {
        title: "Evaluation et sélection des candidats",
        icon: <FaGraduationCap />,
        color: "#4AA3A2",
      },
      {
        title: "Algorithme d'affectation automatique et généation des listes",
        icon: <FaGraduationCap />,
        color: "#F0BE86",
      },
      {
        title: "Communications et notifications aux condidats",
        icon: <FaGraduationCap />,
        color: "#C8D6A2",
      },
      {
        title: "Géneration automatique des documents administartifs",
        icon: <FaGraduationCap />,
        color: "#FBBFB8",
      },
      {
        title: "Historique et suivis des modifications",
        icon: <FaGraduationCap />,
        color: "#BE9CC7",
      },
      {
        title: "Recherche et filtrage avancé des candidateures",
        icon: <FaGraduationCap />,
        color: "#4F996D",
      },
    ],
  },

  {
    title: "Edura Admin",
    icon: <FaCog />,
    iconCheck: <FaTimes />,
    color: "#15676D",
  },
  {
    title: "Edura Biblio",
    icon: <FaBook />,
    iconCheck: <FaTimes />,
    color: "#BD3100",
  },
  {
    title: "Edura tirage",
    icon: <FaFolder />,
    iconCheck: <FaTimes />,
    color: "#5FACD3",
  },
  {
    title: "Edura Stages",
    icon: <FaCog />,
    iconCheck: <FaTimes />,
    color: "#EC781D",
  },

  {
    title: "Edura finance",
    icon: <FaCog />,
    iconCheck: <FaTimes />,
    color: "#8D2C5A",
  },
  {
    title: "Edura Bureau d'ordre",
    icon: <FaCog />,
    iconCheck: <FaTimes />,
    color: "#F4C581",
  },
  {
    title: "Edura saisie gestion des notes à distance",
    icon: <FaCog />,
    iconCheck: <FaTimes />,
    color: "#C49D83",
  },
]

const newsItems = [
  "10/10/2025 : Nouveau module de génération automatique des emplois du temps pour la plateforme EDURA.",
  "10/10/2025 : Intégration d’un nouveau tableau de bord pour la plateforme EDURA.",
  "21/06/2022 :  Faculté des Lettres et des Sciences Humaines de Sfax .",
  "12/06/2008 :  Institut supérieur de Gestion de Gabès .",
  "04/06/2018 :  Institut Supérieur de Musique De Sfax .",
  "10/06/2009 :  Institut Supérieur des Langues Gabès .",
  "28/03/2023 :  L’Ecole de formation professionnelle privée de technologie et de mangement de Sfax .",
  "03/06/2014 :  Institut Supérieur des Sciences humaines de Médenine .",

]
if (localStorage.getItem("userAuthScolarite")) {
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var name = userAuthScolarite.user.name
  var email = userAuthScolarite.user.email
}

class NewsGrid extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalDetail: false,
      modalDevis: false,
      selectedTile: null,
      loading: false,
      paused: false,
      ready: false, // ✅ nouvel état
    };
  }
  componentDidMount() {
    // ✅ Démarre le ticker dès que le composant est monté
    this.setState({ ready: true });
  }
  // ✅ Ouvre/ferme la modal détail
  toggleDetail = (tile = null) => {
    this.setState(prev => ({
      modalDetail: !prev.modalDetail,
      selectedTile: tile,
    }))
  }

  // ✅ Ouvre/ferme la modal devis
  toggleDevis = (tile = null) => {
    this.setState(prev => ({
      modalDevis: !prev.modalDevis,
      selectedTile: tile,
    }))
  }

  // ✅ Envoi de l’email vers Laravel
  handleConfirm = async () => {
    const { selectedTile } = this.state
    this.setState({ loading: true })
    try {
      const response = await API.post("DemandeDevis/envoyer-devis", {
        objet: ` Demande de devis - ${selectedTile?.title || "Sans titre"}`,
        email: email,
        name: name,
        message: `
          <p>Nouvelle demande de devis :</p>
          <p><strong><span style="color: ${
          selectedTile.color
        };font-size: 14px">Nom de l'utilisateur :</span></strong> <span style="font-size: 14px">${name}</span></p>
          <p><strong><span style="color: ${
          selectedTile.color
        };font-size: 14px">Email de l'utilisateur :</span></strong><span style="font-size: 14px">${email}</span> </p>
          <p><strong><span style="color: ${
          selectedTile.color
        };font-size: 14px">Service demandé :</span></strong> <span style="font-size: 14px">${
          selectedTile?.title || "Non spécifié"
        }</span></p>
        `,
      })

      if (response.data.success) {
        this.toggleDevis()
      }
    } catch (error) {
      console.error("Erreur lors de l'envoi du devis :", error)
      alert("❌ Échec de l'envoi du devis.")
    } finally {
      this.setState({ loading: false })
    }
  }

  render() {
    const { modalDetail, modalDevis, selectedTile, loading } = this.state
    const totalLength = newsItems.join(" ").length;
    const duration = Math.max(totalLength * 0.10, 20); // 0.15s par caractère, min 20s

    const tickerStyle = {
      width: "100%",
      overflow: "hidden",
      backgroundColor: "#ff0000",
      color: "#fff",
      padding: "10px 0",
      cursor: "pointer",
      borderRadius: "4px",
      fontSize: "14px",
    };

    // const trackStyle = {
    //   display: "inline-flex",
    //   whiteSpace: "nowrap",
    //   animation: `scroll ${duration}s linear infinite`,
    //   animationPlayState: this.state.paused ? "paused" : "running",
    // };
    const trackStyle = {
      display: "inline-flex",
      whiteSpace: "nowrap",
      animation: "scroll 90s linear infinite", // ✅ démarre dès le chargement
      animationPlayState: this.state.paused ? "paused" : "running",
    };

    const dateStyle = {
      backgroundColor: "#000",
      color: "#fff",
      padding: "2px 8px",
      borderRadius: "4px",
      marginRight: "10px",
      // fontWeight: "bold",
    };

    const itemStyle = {
      marginRight: "50px",
      display: "flex",
      alignItems: "center",
    };

    return (
      <React.Fragment>
        <Col md={12} lg={12} xl={12}>
          <Card>
            <div>
              <Row className="justify-content-center">
                <Col xl={11}>
                  <div>
                    <Row className="align-items-center">
                      <Col style={{marginTop:"15px", marginBottom:"15px"}} md={12}>
                        <div style={tickerStyle} onMouseEnter={() => this.setState({ paused: true })} onMouseLeave={() => this.setState({ paused: false })}>
                          <div style={trackStyle}>
                            {newsItems.map((item, index) => {
                              const [date, ...textParts] = item.split(" : ");
                              const text = textParts.join(" : ");
                              return (
                                <span key={index} style={itemStyle}>
                                  <span style={dateStyle}>{date}</span>
                                  <span>{text}</span>
                                </span>
                              );
                            })}
                            {/* Dupliquer les items pour un scroll continu */}
                            {newsItems.map((item, index) => {
                              const [date, ...textParts] = item.split(" : ");
                              const text = textParts.join(" : ");
                              return (
                                <span key={`dup-${index}`} style={itemStyle}>
                                  <span style={dateStyle}>{date}</span>
                                  <span>{text}</span>
                                </span>
                              );
                            })}
                          </div>
                          <style> {` @keyframes scroll {100% { transform: translateX(100%); } 100% { transform: translateX(-100%); }}`} </style>
                        </div>
                      </Col>
                    </Row>
                    <Row  className="align-items-center">
                      <Col md={6}>
                        <img src={logo} alt="logo" />
                      </Col>
                      <Col md={6} style={{ top: "15px" }}>
                        <div style={{ display: "flex", justifyContent: "end" }}>
                          <a
                            href="http://www.edura.tn/"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#2F70A9",
                              fontSize: "16px",
                              display: "flex",
                              justifyContent: "end",
                            }}
                          >
                            www.edura.tn
                          </a>
                        </div>
                      </Col>
                    </Row>

                    <hr className="mb-4" />

                    {/* Grille des tuiles */}
                    <Row>
                      <div
                        style={{
                          width: "100%",
                          display: "grid",
                          gridTemplateColumns:
                            "repeat(auto-fill, minmax(200px, 1fr))",
                          // gridAutoRows: "200px",
                          gap: "25px",
                          padding: "10px",
                        }}
                      >
                        {tiles.map((tile, index) => (
                          <div
                            key={index}
                            style={{
                              backgroundColor: tile.color,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              borderRadius: "10px",
                              cursor: "pointer",
                              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                              transition: "transform 0.3s, box-shadow 0.3s",
                              color: "#fff",
                            }}
                            onMouseEnter={e => {
                              e.currentTarget.style.transform = "scale(1.05)"
                              e.currentTarget.style.boxShadow =
                                "0 10px 20px rgba(0,0,0,0.3)"
                            }}
                            onMouseLeave={e => {
                              e.currentTarget.style.transform = "scale(1)"
                              e.currentTarget.style.boxShadow =
                                "0 4px 8px rgba(0,0,0,0.2)"
                            }}
                          >
                            <div
                              style={{
                                padding: "15px",
                                textAlign: "center",
                                flexGrow: 1,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                style={{
                                  backgroundColor: "#fff",
                                  borderRadius: "10%",
                                  width: "30px",
                                  height: "22px",
                                  // display: "flex",
                                  // alignItems: "flex-start",
                                  // justifyContent: "center",
                                  // margin: "0 auto 15px auto",
                                }}
                              >
                                {tile.iconCheck &&
                                  React.cloneElement(tile.iconCheck, {
                                    size: 15,
                                    color:
                                      tile.iconCheck.type === FaCheck
                                        ? "green"
                                        : "red",
                                  })}
                              </div>
                              <div
                                style={{
                                  backgroundColor: "#fff",
                                  borderRadius: "50%",
                                  width: "70px",
                                  height: "70px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  margin: "0 auto 15px auto",
                                }}
                              >
                                {React.cloneElement(tile.icon, {
                                  size: 35,
                                  color: tile.color,
                                })}
                              </div>
                              <div
                                style={{ fontSize: "16px", fontWeight: "bold" }}
                              >
                                {tile.title}
                              </div>
                            </div>

                            {/* Actions */}
                            <div
                              style={{
                                backgroundColor: "#fff",
                                padding: "8px",
                                display: "flex",
                                justifyContent: "space-around",
                                alignItems: "center",
                                borderTop: `2px solid ${tile.color}`,
                              }}
                            >
                              <a
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "5px 10px",
                                  border: `1px solid ${tile.color}`,
                                  borderRadius: "5px",
                                  color: tile.color,
                                  fontWeight: "bold",
                                  textDecoration: "none",
                                  gap: "11px",
                                  transition: "0.3s",
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.backgroundColor =
                                    tile.color
                                  e.currentTarget.style.color = "#fff"
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.backgroundColor = "#fff"
                                  e.currentTarget.style.color = tile.color
                                }}
                                onClick={() => this.toggleDetail(tile)}
                              >
                                <FaEye
                                  style={{ fontSize: "20px", color: "inherit" }}
                                />{" "}
                                Détail
                              </a>
                              <a
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "5px 10px",
                                  border: `1px solid ${tile.color}`,
                                  borderRadius: "5px",
                                  color: tile.color,
                                  fontWeight: "bold",
                                  textDecoration: "none",
                                  gap: "11px",
                                  transition: "0.3s",
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.backgroundColor =
                                    tile.color
                                  e.currentTarget.style.color = "#fff"
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.backgroundColor = "#fff"
                                  e.currentTarget.style.color = tile.color
                                }}
                                onClick={() => this.toggleDevis(tile)}
                              >
                                <FaFileInvoiceDollar
                                  style={{ fontSize: "20px", color: "inherit" }}
                                />{" "}
                                Devis
                              </a>
                            </div>
                          </div>
                        ))}
                      </div>
                    </Row>
                  </div>
                </Col>

                <Col md={12} lg={12} xl={12}>
                  <Card>
                    <div style={{ padding: "20px" }}>
                      <h2>Tableau de bord</h2>
                      <Stats />
                    </div>
                  </Card>
                </Col>
              </Row>
            </div>
          </Card>
        </Col>
        {/* Modal Détail */}
        <Modal
          isOpen={modalDetail}
          toggle={() => this.toggleDetail()}
          centered
          size="xl"
        >
          <ModalHeader toggle={() => this.toggleDetail()} tag="h4">
            {selectedTile ? selectedTile.icon : "Détail"}{" "}
            {selectedTile ? selectedTile.title : "Détail"}
          </ModalHeader>
          <ModalBody>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)", // 4 colonnes
                gap: "20px",
                padding: "10px",
              }}
            >
              {selectedTile?.details?.map((card, index) => (
                <div
                  key={index}
                  style={{
                    backgroundColor: card.color,
                    borderRadius: "10px",
                    padding: "20px",
                    textAlign: "center",
                    color: "#fff",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                    transition: "transform 0.3s, box-shadow 0.3s",
                    cursor: "pointer",
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.transform = "scale(1.05)"
                    e.currentTarget.style.boxShadow =
                      "0 10px 20px rgba(0,0,0,0.3)"
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.transform = "scale(1)"
                    e.currentTarget.style.boxShadow =
                      "0 4px 8px rgba(0,0,0,0.2)"
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                      width: "60px",
                      height: "60px",
                      margin: "0 auto 10px auto",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {React.cloneElement(card.icon, {
                      size: 28,
                      color: card.color,
                    })}
                  </div>
                  <h6>{card.title}</h6>
                </div>
              ))}
            </div>
          </ModalBody>
        </Modal>
        {/* ✅ Modal Devis */}
        <Modal isOpen={modalDevis} toggle={() => this.toggleDevis()} centered>
          <ModalHeader toggle={() => this.toggleDevis()} tag="h4">
            {selectedTile ? `Devis - ${selectedTile.title}` : "Devis"}
          </ModalHeader>
          <ModalBody>
            <p style={{ textAlign: "center" }}>
              {selectedTile
                ? `Vous demandez un devis pour : ${selectedTile.title}`
                : "Aucune donnée"}
            </p>
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <Button
                color="success"
                className="btn-rounded"
                onClick={this.handleConfirm}
                disabled={loading}
              >
                {loading ? "Envoi..." : "Confirmer"}
              </Button>
              <Button
                className="btn-rounded"
                color="warning"
                onClick={() => this.toggleDevis()}
              >
                Annuler
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </React.Fragment>
    )
  }
}

NewsGrid.propTypes = {
  t: PropTypes.any,
}

export default withRouter(withTranslation()(NewsGrid))
